export const homework = {
    date: "2022-08-14",
    student: "Анастасия Соболевская",
    lesson: "Academic English (IELTS or TOEF...)",
    status: "Выполнено",

    description: {
        title: 'Описание домашнего задания',
        text: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона, а также реальное распределение букв и пробелов в абзацах, которое не получается при простой дубликации. При оценке дизайна и композиции читаемый текст мешает сосредоточиться.'
    },
    materials: {
        title: 'Материалы домашнего задания',
        attachments: [
            { name: "Document-name-01.pdf", size: "12 Kb" },
            { name: "Document-name-02.pdf", size: "12 Kb" },
            { name: "Document-with-long-name-description-03.pdf", size: "12 Kb" }
        ],
    },
    studentResponse: {
        title: "Ответ студента",
        text: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона, а также реальное распределение букв и пробелов в абзацах, которое не получается при простой дубликации. При оценке дизайна и композиции читаемый текст мешает сосредоточиться.',
        attachments: [
            { name: "Document-name-01.pdf", size: "12 Kb" },
            { name: "Document-name-02.pdf", size: "12 Kb" },
            { name: "Document-with-long-name-description-03.pdf", size: "12 Kb" }
        ]
    },
    hasResponse: {
        title: 'Ответ студента',
        text: 'Нет ответа'
    }
};